import {
  Text,
  MenuItemOption,
  MenuItemOptionProps,
  forwardRef,
  HStack,
} from '@cdl/heartbeat-react';
import { IconStatus } from '../../../../shared/components/status/IconStatus';

type Props = {
  statusOption: string;
} & MenuItemOptionProps;

export const OptionStatus = forwardRef<Props, 'button'>(
  ({ statusOption, ...rest }, ref) => {
    return (
      <MenuItemOption ref={ref} {...rest}>
        <HStack alignItems='center' fontWeight='regular' py='s'>
          <IconStatus statusOption={statusOption} />
          <Text textTransform='capitalize'>{statusOption}</Text>
        </HStack>
      </MenuItemOption>
    );
  },
);

OptionStatus.id = 'MenuItemOption';
